import Vue from "vue";
import qs from "qs";

import config from "./config.js";
import Icons from './components/annot8/icons';

const cases = {
  search: params => {
    const http = Vue.prototype.$http;
    return http.get(config.api.url + "/juris?" + qs.stringify(params));
  },

  view: (params, opinions = false) => {
    const http = Vue.prototype.$http;
    if(opinions) {
      return http.get(config.api.url + "/juris/" + params.id + '?opinions=1');
    }
    return http.get(config.api.url + "/juris/" + params.id);
  }
};

const laws = {
  search: params => {
    const http = Vue.prototype.$http;
    return http.get(config.api.url + "/laws?" + qs.stringify(params));
  },

  view: params => {
    const http = Vue.prototype.$http;
    return http.get(config.api.url + "/laws/" + params.id);
  }
};

const annotations = {
  search: params => {
    const http = Vue.prototype.$http;
    return http.get(config.api.url + "/annotations?" + qs.stringify(params));
  },

  create: params => {
    //console.log("create");
    const http = Vue.prototype.$http;
    return http({
      method: "POST",
      url: config.api.url + "/annotations",
      data: params,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    });
  },

  update: params => {
    //console.log(params);
    const http = Vue.prototype.$http;
    return http({
      method: "PUT",
      url: config.api.url + "/annotations/" + params.annotation.oid,
      data: params
    });
  },

  delete: params => {
    const http = Vue.prototype.$http;
    return http({
      method: "DELETE",
      url: config.api.url + "/annotations/" + params.annotation.oid,
      data: params
    });
  },

  clear: params => {
    const http = Vue.prototype.$http;
    return http({
      method: "DELETE",
      url: config.api.url + "/annotations/clear",
      data: params
    });
  },

  digest: params => {
    var annotations = params.annotations;

    //console.log(params);

    var gather = {
      1: { label: "Facts", contents: "" },
      2: { label: "Issues", contents: "" },
      3: { label: "Ruling", contents: "" },
      4: { label: "Principles", contents: "" },
    };

    annotations.forEach(a => {
      gather[a.tagid]["contents"] = `${gather[a.tagid]["contents"]}<p>${a.quote}</p>${a.text ? '<i class="digest-comment">' + a.text + '</i>' : ''}`;
    });

    var content = "";
    Object.keys(gather).forEach(g => {
      if (gather[g].contents.trim() !== "") {
        content += `<h3><strong># ${gather[g].label}</strong></h3>
       ${gather[g].contents}
       <br/>`;
      }
    });

    return content;
  },
  countAnnotations: params => {
    const http = Vue.prototype.$http;
    return http.get(config.api.url + "/annotations/count?" + qs.stringify(params));
  }
};

const casebooks = {
  search: params => {
    const http = Vue.prototype.$http;
    return http.get(config.api.url + "/casebooks?" + qs.stringify(params));
  },

  view: params => {
    const http = Vue.prototype.$http;
    return http.get(
      config.api.url + "/casebooks/" + params.id + "?" + qs.stringify(params)
    );
  },

  create: params => {
    const http = Vue.prototype.$http;
    return http({
      method: "POST",
      url: config.api.url + "/casebooks",
      data: params
    });
  },

  update: params => {
    const http = Vue.prototype.$http;
    return http({
      method: "PUT",
      url: config.api.url + "/casebooks/" + params.id,
      data: params
    });
  },

  delete: params => {
    const http = Vue.prototype.$http;
    return http({
      method: "DELETE",
      url: config.api.url + "/casebooks/" + params.id,
      data: params
    });
  }
};

const digests = {
  search: params => {
    const http = Vue.prototype.$http;
    return http.get(config.api.url + "/digests?" + qs.stringify(params));
  },

  view: params => {
    const http = Vue.prototype.$http;
    return http.get(
      config.api.url + "/digests/" + params.id + "?" + qs.stringify(params)
    );
  },

  create: params => {
    const http = Vue.prototype.$http;
    return http({
      method: "POST",
      url: config.api.url + "/digests",
      data: params
    });
  },

  update: params => {
    const http = Vue.prototype.$http;
    return http({
      method: "PUT",
      url: config.api.url + "/digests/" + params.id,
      data: params
    });
  },

  delete: params => {
    const http = Vue.prototype.$http;
    return http({
      method: "DELETE",
      url: config.api.url + "/digests/" + params.id,
      data: params
    });
  }
};

const mixins = {
  data: {
    beforePrintHandler: null,
    afterPrintHandler: null
  },
  methods: {
    morphLinks(target) {
      var aa = target.querySelectorAll("a");
      Array.prototype.forEach.call(aa, async (a, index) => {
        var _route = a.href
          .replace("//", "")
          .split(":");
        //console.log(_route);

        if (_route[0] == 'case') {
          let cls = 'icons';
          let id = _route[1];
          let pr = "You have not highlighted principles from this case.";
          if (_route[1].startsWith('c')) {
            id = parseInt(_route[1].substring(1), 16);
          }

          var res = await this.$lawyerly.annotations.search({
            user: this.$store.state.user.user.email,
            docId: id,
            typeId: 1,
            tagid: 4
          });

          if (res) {
            if (res.data) {
              if (res.data.length > 0) {
                cls = 'icons case enable';
                pr = "";
                res.data.forEach(p => {
                  pr += `<p><span class="notebook-principle-text">${p.quote}</span></p>`;
                });
              }
            }
          }

          var element = document.createElement("span");
          element.innerHTML = Icons["si-awesome-tag"];
          element.className = cls;
          element.onclick = () => { showPrinciples(index, _route[1]) };
          element.title = 'show #principles';

          a.parentNode.insertBefore(element, a.nextSibling);

          var div = document.createElement("div");
          div.className = 'data';
          div.id = 'principle-' + index;
          div.style.height = '0px';
          div.innerHTML = `<div style="padding: 0.8em;"><span>${pr}</span></div>`;

          a.parentNode.insertBefore(div, element.nextSibling);
        }

        if (_route[0] == 'law') {
          let cls = 'icons';
          let id = _route[1];
          let pr = "You have not highlighted from this law.";
          // if(_route[1].startsWith('l')) {
          //   id = parseInt(_route[1].substring(1), 16);
          // }

          var res = await this.$lawyerly.annotations.search({
            user: this.$store.state.user.user.email,
            docId: id,
            typeId: 2,
            tagid: 1
          });

          if (res) {
            if (res.data) {
              if (res.data.length > 0) {
                cls = 'icons law enable';
                pr = "";
                res.data.forEach(p => {
                  pr += `<p><span class="notebook-highlight-text">${p.quote}</span></p>`;
                });
              }
            }
          }

          var element = document.createElement("span");
          element.innerHTML = Icons["si-awesome-tag"];
          element.className = cls;
          element.onclick = () => { showPrinciples(index, _route[1]) };
          element.title = 'show #highlights';

          a.parentNode.insertBefore(element, a.nextSibling);

          var div = document.createElement("div");
          div.className = 'data';
          div.id = 'principle-' + index;
          div.style.height = '0px';
          div.innerHTML = `<div style="padding: 0.8em;"><span>${pr}</span></div>`;

          a.parentNode.insertBefore(div, element.nextSibling);
        }

        a.addEventListener("mousedown", evt => {
          var route = evt.srcElement.dataset["route"]
            .replace("//", "")
            .split(":");
          if (route.length >= 2) {
            this.$nextTick(() => {
              if (route[0] === "case") {
                route[0] = "cases";
              } else if (route[0] === "law") {
                route[0] = "laws"
              }
              this.$router.push("/" + route[0] + "/" + route[1]);
            });
          }
          evt.preventDefault();
          return false;
        });

        a.dataset["route"] = a.href;
        a.href = "/#" + this.$store.state.route.path;
      });
    },
    renderPrintable(title, content, type = null) {
      const printable = document.createElement("div");
      printable.className = "printable";
      printable.id = "printable";
      if (!type) {
        printable.innerHTML = `<center class="header"><img src="img/lawyerly-invert.logo.png"/><p>A Law Student's Companion</p></center>${title}${content}`;
      } else {
        printable.innerHTML = `<center class="header"><img src="img/lawyerly-invert.logo.png"/><p>A Law Student's Companion</p></center><p>${type}</p><h1 class="digest-title">${title}</h1><hr class="title-hr"/>${content}`;
      }
      document.body.appendChild(printable);
      const main = document.getElementById("main");
      main.className += " main";
    },
    removePrintable() {
      document.getElementById("printable").remove();
      const main = document.getElementById("main");
      main.className = main.className.replace(" main", "");
    },
    mountPrintable(title, content, type = null) {
      this.beforePrintHandler = () => {
        this.renderPrintable(title, content, type);
      };
      this.afterPrintHandler = () => {
        this.removePrintable();
      }

      window.addEventListener("beforeprint", this.beforePrintHandler);
      window.addEventListener("afterprint", this.afterPrintHandler);
    },

    unMountPrintable() {
      window.removeEventListener("beforeprint", this.beforePrintHandler);
      window.removeEventListener("afterprint", this.afterPrintHandler);
      this.beforePrintHandler = null;
      this.afterPrintHandler = null;
    }
  }
};

export default {
  annotations,
  casebooks,
  digests,
  cases,
  laws,
  mixins,
};
